module.exports = __webpack_public_path__ + "static/mazecoasters-19757b196f4617c7de054e0fcdad8ec7.png";